// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__ug6Tn","choiceBoxes":"toolbarselects_choiceBoxes__1rTBT","simpleField":"toolbarselects_simpleField__1KjJ3"};